$(document).ready(function(e) {	
    

    $('.review_slide_row').slick({
        dots: false,
        slidesToShow:6,
        slidesToScroll: 1,
        variableWidth: false,
        centerMode: false,
        arrows:true,
        autoplay: false,
        infinite: false,
        responsive: [				
            {
                breakpoint: 1200,
                settings:  {
                slidesToShow:4,
            }
            },					
            {
                breakpoint: 1024,
                settings:  {
                slidesToShow:3,
            }
            },		
            {
                breakpoint: 767,
                settings: {
                slidesToShow:1,
                variableWidth: true,
                centerMode: true,
                infinite: true,
            }
            },
        ] 
    });
    
    //accordion JS 
    $(".accordion").click(function() {
        
        var questionDiv = $(this);
        var answerDiv   = $(this).next('.acdn-content');
        var idx = $('.acdn-content').index(answerDiv);
        
        $('.acdn-content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
                $(ansDiv).slideUp(500, function() {
                    $(ansDiv).prev('.accordion').removeClass('accordion-open');
                });
            }
        });
                    
        if (answerDiv.is(':visible')) {
            answerDiv.stop().slideUp(500, function() {
                questionDiv.removeClass('accordion-open');
            });
        } else {
        questionDiv.addClass('accordion-open');
        answerDiv.stop().slideDown(500);
        }
    });
    
    
    var video = $('#myVdo video')[0];
    
    $('.ugc1').click(function(e) {
        $('.ugc-modal').addClass('active');
        $('.video-container').show();
        
        var videoFile = $(this).attr('data-vdo');
        video.src = videoFile;
        video.load();
        video.play();
    });	
    
    $('.ugc-close, .ugc-modal').click(function(e) {
        video.src = '';
        $('.ugc-modal').removeClass('active');
        $('.video-container').hide();
    });
    
    
    $(".btn_scorall").click(function() {
        $('html, body').animate({
            scrollTop: $("#package").offset().top - 0
        }, 2000);
    });
    
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 500,
    });
    
});


$(window).scroll(function(){	
    
    var winScroll = $(window).scrollTop() + 150;
    var stepScroll1 = $('.step1').offset().top - 100;
    var stepScroll2 = $('.step2').offset().top - 100;
    var stepScroll3 = $('.step3').offset().top - 100;
    
    if (winScroll > stepScroll1 ){
        $('.step1').addClass('active');
    }else{
        $('.step1').removeClass('active');
    }
    
    if (winScroll > stepScroll2 ){
        $('.step2').addClass('active');
    }else{
        $('.step2').removeClass('active');
    }
    
    if (winScroll > stepScroll3 ){
        $('.step3').addClass('active');
    }else{
        $('.step3').removeClass('active');
    }

    
});